/// <reference path="~/js/global.js"/>
/// <reference path="~/js/lib/backbone.js"/>
/// <reference path="~/js/lib/lodash.js"/>
/// <reference path="~/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="~/js/viz/profile/config/Config.js"/>

(function(Backbone, _) {
  "use strict";

  var ns;

  ns = window.nspace("ccc.viz.profile.views");

  /**
   * Monitors the state of the indicators in the model and updates the raw data link accordingly.
   */
  ns.RawDataHrefView = Backbone.View.extend({
    el: ".option-icons-list .icon-raw-data",

    initialize: function(options) {
      _.bindAll(this);

      this.model.on("change", this.render);
    },

    render: function() {
      var response, indicatorGroupsIds;

      response = this.model.get("response");

      indicatorGroupsIds = _(response.data)
        .map(function(indicatorTables) {
          return indicatorTables.indicatorGroupId;
        })
        .uniq()
        .value();

      this.$el.attr("href", "/data/download#0/" + indicatorGroupsIds);
    }
  });
})(Backbone, _);
